import { schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'
import { documentId } from 'firebase/firestore'

import { collections } from '@/schema'

export const dashboardTransportRequestsQuery = (regionId: string, eveningId: number) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['transportRequests', regionId, eveningId],
    factory: collections.transportRequests,
    query: {
      name: `All transport requests for region ${regionId} and evening ${eveningId}`,
      where: [
        ['regionId', '==', regionId],
        ['eveningId', '==', eveningId],
        ['status', 'not-in', ['draft', 'deleted_draft', 'submitted', 'error']],
      ],
    },
  })

export const transportRequestsQuery = (transportRequestIds: string[]) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['transportRequests', transportRequestIds],
    factory: collections.transportRequests,
    query: {
      name: `Transport requests ${transportRequestIds.join(', ')}`,
      where: [[documentId(), 'in', transportRequestIds]],
    },
  })
